import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { AuditPlannerExceptionsDictionary, ShortlistProfile } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { humanize, titleize } from "underscore.string";

import { getExceptionDetails } from "../helpers";
import css from "../modals.module.scss";

type ReasonForExceptionProps = {
  exception?: AuditPlannerExceptionsDictionary;
  profile: ShortlistProfile;
};

export const ReasonForException = ({ exception, profile }: ReasonForExceptionProps) => {
  const { t } = useTranslation("auditPlanner");
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { availability, compliance, isMultiple, keys: exceptionKeys } = getExceptionDetails(exception);
  const exceptionKeySelected = exceptionKeys[selectedIndex];

  return (
    <>
      {isMultiple && (
        <Inline alignItems="center" justifyContent="space-between">
          <Typography variant="bodyBold">
            {t(`modals.auditPlannerExceptions.${exceptionKeySelected}`)}
          </Typography>
          <Inline alignItems="center" gap="spacingSm">
            <ActionIcon
              name="chevron-left"
              disabled={selectedIndex <= 0}
              onClick={() => setSelectedIndex((index) => index - 1)}
            />
            <Typography variant="bodyRegular">
              {selectedIndex + 1}/{exceptionKeys.length}
            </Typography>
            <ActionIcon
              name="chevron-right"
              disabled={selectedIndex >= exceptionKeys.length - 1}
              onClick={() => setSelectedIndex((index) => index + 1)}
            />
          </Inline>
        </Inline>
      )}
      <span style={{ fontWeight: isMultiple ? 300 : "inherit" }}>
        {exceptionKeySelected === "availability" &&
          availability?.isqmOverbooking &&
          availability?.isqmOverbooking?.length > 0 && (
            <div key="isqmOverbooking" className={css.text}>
              {Object.values(availability.isqmOverbooking).map(({ startDate, weeks }) => (
                <div key={startDate}>{t("modals.weekCommencingOn", { startDate, weeks })}</div>
              ))}
            </div>
          )}
        {exceptionKeySelected === "compliance" && (
          <div className={css.text}>
            {t("modals.reasonForExceptionProfileMissing", {
              name: getProfileName(profile),
              values: Object.entries(compliance || {})
                .map(([name, tags]) => `${titleize(humanize(name))}: ${tags.sort().join(", ")}`)
                .join(", ")
            })}
          </div>
        )}
      </span>
    </>
  );
};
